import { IDiscount } from '@core/interfaces/cart/discount.interface';
import { AAGUID } from '@interticket/core';
import { DiscountType } from '../../enums/cart/discount-type.enum';

export class Discount implements IDiscount {

  eventIds?: AAGUID[];
  couponId?: AAGUID;
  discount?: string;
  discountType: DiscountType;
  discountRemainingCount: number;
  errorMessage?: string;

  constructor(iDiscount: IDiscount) {
    this.eventIds = Array.isArray(iDiscount.eventIds) ? iDiscount.eventIds : [];
    this.couponId = iDiscount.couponId;
    this.discount = iDiscount.discount;
    this.discountType = iDiscount.discountType;
    this.discountRemainingCount = iDiscount.discountRemainingCount;
    this.errorMessage = iDiscount.errorMessage;
  }

}
